import { Box, Typography } from '@lingoda/ui';
import {
    type AchievementFragment,
    useStudentBookingClassStatusSuspenseQuery,
} from '@lingoda/monolith-graphql';
import { trans } from '@lingoda/i18n';
import { StyledHorizontalLine } from '../common/StyledHorizontalLine';
import { AchievementItem } from './AchievementItem';
import { RecapAchievementItem } from './RecapAchievementItem';

export interface TopAchievementsLayoutProps {
    achievements: ReadonlyArray<AchievementFragment>;
    loading: boolean;
    isYearlyRecapVisible: boolean;
}

export const TopAchievementsLayout = ({
    achievements,
    loading,
    isYearlyRecapVisible,
}: TopAchievementsLayoutProps) => {
    const { data } = useStudentBookingClassStatusSuspenseQuery();
    const hasBookedClass = data.student.hasBookedClass;

    return (
        <>
            {!hasBookedClass && (
                <Box display="flex" data-testid="achievements-booking-status">
                    <StyledHorizontalLine />
                    <Typography variant="subtitle2" alignSelf="center" htmlColor="text.secondary">
                        {trans('take-a-class-to-earn-your-first-badge', {}, 'student-today')}
                    </Typography>
                </Box>
            )}
            <Box component="ul" sx={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {isYearlyRecapVisible && <RecapAchievementItem component="li" />}
                {achievements.map((achievement) => (
                    <AchievementItem
                        key={achievement.id}
                        achievement={achievement}
                        loading={loading}
                        component="li"
                    />
                ))}
            </Box>
        </>
    );
};
